import ItemViewState from '../store/schema/ItemViewState';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';

export default createLegacyActionWithDatapoint('toggleUndoDarkMode', {
    name: (viewState: ItemViewState) => {
        return viewState.undoDarkMode ? 'ToggleDarkModeOn' : 'ToggleDarkModeOff';
    },
    actionSource: 'ReadingPane',
})(function toggleUndoDarkMode(viewState: ItemViewState) {
    if (viewState) {
        viewState.undoDarkMode = !viewState.undoDarkMode;
    }
});
